import { useEffect, useState } from "react";
import { DraftSubmission } from "../../../data-model/draftSubmission";

export const useCptTableGeneration = (draftSubmission?: DraftSubmission) => {
  const [cptTableData, setCptTableData] = useState<
    {
      cptCode: string;
      cptDescription: string;
    }[]
  >([]);
  useEffect(() => {
    if (draftSubmission) {
      setCptTableData(
        draftSubmission.j_codes.map((jCode) => ({
          cptCode: jCode.j_code,
          cptDescription: jCode.description,
        })),
      );
    }
  }, [draftSubmission]);
  return {
    cptTableData,
  };
};
